import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../core/design-system/components/Button';
import CityInputs from '../../../../shared/components/CityInputs/CityInputs'; 
import './common.css';
import './LocationStep.css';

const LocationStep = ({ onComplete }) => {
  const { t } = useTranslation('onboarding');
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = () => {
    if (!location?.placeId) {
      setError(t('location.error.required'));
      return;
    }
    onComplete({ location });
  };

  return (
    <div className="location-step-container">
      <div className="location-step-content">
        <CityInputs
          value={location}
          onChange={setLocation}
          placeholder={t('location.placeholder.address')}
          error={error}
        />
      </div>
      
      <Button 
        variant="primary"
        className="step-submit-button"
        onClick={handleSubmit}
        disabled={!location?.placeId}
      >
        {t('location.continue')}
      </Button>
    </div>
  );
};

export default LocationStep; 